import currentTimeZone from './current-time-zone';
import formatToTimeZone from './format-to-time-zone';
import { fromZonedTime } from 'date-fns-tz';
import { A } from '@ember/array';
import { parseISO, getTime, startOfDay, endOfDay } from 'date-fns';

// This helper converts local time inputs to the correct UTC time
// by finding the time that's between the airing start and end time

// 1 => 1 hour, assume 0 minutes and 0 seconds
// 11 => 11 hours or 1 hour, assume 10 minutes

function generatePossibleTimes(time) {
  function generateTimes(time) {
    if (time.length == 1) {
      addPossibleTime(
        { startHour: time, startMinute: 0, startSecond: 0, ordinal },
        possibleTimes,
      );

      addPossibleTime(
        { startHour: time * 10, startMinute: 0, startSecond: 0, ordinal },
        possibleTimes,
      );
    } else if (time.length == 2) {
      addPossibleTime(
        {
          startHour: time.slice(0, 2),
          startMinute: 0,
          startSecond: 0,
          ordinal,
        },
        possibleTimes,
      );
      addPossibleTime(
        {
          startHour: time.slice(0, 1),
          startMinute: time.slice(1, 2) * 10,
          startSecond: 0,
          ordinal,
        },
        possibleTimes,
      );
    } else if (time.length == 3) {
      addPossibleTime(
        {
          startHour: time.slice(0, 1),
          startMinute: time.slice(1, 3) || 0,
          startSecond: 0,
          ordinal,
        },
        possibleTimes,
      );

      addPossibleTime(
        {
          startHour: time.slice(0, 2),
          startMinute: time.slice(2, 3) * 10,
          startSecond: 0,
          ordinal,
        },
        possibleTimes,
      );
    } else if (time.length == 4) {
      addPossibleTime(
        {
          startHour: time.slice(0, 2),
          startMinute: time.slice(2, 4) || 0,
          startSecond: 0,
          ordinal,
        },
        possibleTimes,
      );

      addPossibleTime(
        {
          startHour: time.slice(0, 1),
          startMinute: time.slice(1, 3) || 0,
          startSecond: (time.slice(3, 4) || 0) * 10,
          ordinal,
        },
        possibleTimes,
      );
    } else if (time.length == 5) {
      addPossibleTime(
        {
          startHour: time.slice(0, 2),
          startMinute: time.slice(2, 4) || 0,
          startSecond: time.slice(4, 5) * 10 || 0,
          ordinal,
        },
        possibleTimes,
      );

      addPossibleTime(
        {
          startHour: time.slice(0, 1),
          startMinute: time.slice(1, 3) || 0,
          startSecond: time.slice(3, 5) || 0,
          ordinal,
        },
        possibleTimes,
      );
    } else {
      addPossibleTime(
        {
          startHour: time.slice(0, 2),
          startMinute: time.slice(2, 4) || 0,
          startSecond: time.slice(4, 6) || 0,
          ordinal,
        },
        possibleTimes,
      );

      addPossibleTime(
        {
          startHour: time.slice(0, 1),
          startMinute: time.slice(1, 3) || 0,
          startSecond: time.slice(3, 5) || 0,
          ordinal,
        },
        possibleTimes,
      );
    }
  }

  let matches = time.match(/[AaPp][Mm]?/);
  let ordinal = matches ? matches[0] : null;
  let possibleTimes = [];
  let startHour,
    startMinute,
    startSecond = 0;
  time = time.replace(ordinal, '').trim();

  if (time.match(/:/)) {
    [startHour, startMinute, startSecond = 0] = time.split(':');
    addPossibleTime(
      { startHour, startMinute, startSecond, ordinal },
      possibleTimes,
    );
  } else {
    generateTimes(time);
    // if (time != time.slice(-6)) {
    //   generateTimes(time.slice(-6));
    // }
  }

  return possibleTimes;
}

function addPossibleTime(timeInfo, possibleTimes) {
  let { startHour, startMinute, startSecond, ordinal } = timeInfo;

  startHour = parseInt(startHour, 10);
  startMinute = parseInt(startMinute, 10) || 0;
  startSecond = parseInt(startSecond, 10) || 0;

  if (ordinal && ordinal.toLowerCase().match(/p/)) {
    if (startHour < 12) {
      startHour = startHour + 12;
    }
  } else if (ordinal && ordinal.toLowerCase().match(/a/)) {
    if (startHour == 12) {
      startHour = 0;
    }
  } else {
    // no ordinal sepcified
    if (startHour < 12) {
      possibleTimes.push({
        hour: ('0' + (startHour + 12)).slice(-2),
        minute: ('0' + startMinute).slice(-2),
        second: ('0' + startSecond).slice(-2),
      });
    } else if (startHour == 12) {
      possibleTimes.push({
        hour: '00',
        minute: ('0' + startMinute).slice(-2),
        second: ('0' + startSecond).slice(-2),
      });
    }
  }

  possibleTimes.push({
    hour: ('0' + startHour).slice(-2),
    minute: ('0' + startMinute).slice(-2),
    second: ('0' + startSecond).slice(-2),
  });
}

function generatePossibleDateStrings(
  localStartTimeString,
  localEndTimeString,
  times,
) {
  let possibilities = [];

  A([localStartTimeString, localEndTimeString])
    .uniq()
    .forEach((dateString) => {
      times.forEach((time) => {
        possibilities.push(
          `${dateString}T${time.hour}:${time.minute}:${time.second}`,
        );
      });
    });

  return possibilities;
}

export default function inferTime(time, hash) {
  if (!time) return '';

  let startTime = hash.start;
  let endTime = hash.end;
  let timeZone = hash.timeZone;

  let debug = hash.debug;

  if (!hash.start && !hash.end && hash.date) {
    startTime = startOfDay(hash.date);
    endTime = endOfDay(hash.date);
  }

  if (!timeZone) {
    timeZone = currentTimeZone();
  }

  if (debug) {
    console.group(
      `-> ${time} // need time between ${startTime} and ${endTime} in ${timeZone}`,
    ); //eslint-disable-line
  }
  let possibleTimes = generatePossibleTimes(time);

  if (debug) {
    console.log('possible times: ', possibleTimes);
  }

  let utcStartTimeString = formatToTimeZone(startTime, 'yyyy-MM-dd', {
    timeZone,
  });

  // We used to be clever about this and try to detect if the date spanned across days in UTC time
  // but switching to date-fns-tz made that tricky due to bugs. So we'll just brute force it and check
  let utcEndTimeString = formatToTimeZone(endTime, 'yyyy-MM-dd', { timeZone });

  if (debug) {
    console.log(`localStartTimeString: ${utcStartTimeString}`); //eslint-disable-line
    console.log(`localEndTimeString: ${utcEndTimeString}`); //eslint-disable-line
  }
  let possibleDateStrings = generatePossibleDateStrings(
    utcStartTimeString,
    utcEndTimeString,
    possibleTimes,
  );
  // console.log(`possible date strings: ${possibleDateStrings}`);
  let possibleDates = possibleDateStrings.map((d) => {
    try {
      let parsedDate = parseISO(d);
      let zonedTime = fromZonedTime(parsedDate, timeZone);
      return zonedTime;
    } catch {
      // nothing
    }
  });

  if (debug) {
    console.log(`possible dates: ${possibleDates}`);
    console.log(`timezone: ${timeZone}`); //eslint-disable-line
  }
  let matched = possibleDates.filter((possibility) => {
    let result =
      getTime(possibility) <= getTime(endTime) &&
      getTime(possibility) >= getTime(startTime);

    if (debug) {
      console.log(
        `${result ? 'YES' : 'NO'}: ${time} -> ${possibility} || ${startTime} - ${endTime}`,
      ); //eslint-disable-line
    }
    return result;
  });
  // .sort((t1, t2) => {
  //   return t1.getTime() < t2.getTime() ? -1 : 1;
  // });
  if (debug) {
    console.log('matched:', matched);
    console.groupEnd();
  }
  if (matched.length >= 1) {
    // console.log("Match")
    return matched[0];
  } else {
    return false;
  }
}
